import { useContext, useEffect, useState } from 'react';

import { GameContext, ViewContext } from '@/state/contexts';
import '@/style/HandModal.css';
import { performActionType } from '@/type/performAction';
import { logg } from '@/util/logg';
import { makeDecisionTurnOrder } from '@lc/const/socketEvent';

const DecisionTurnOrderModal = () => {
	const { playerStateArray, performAction, gameStatus }: any =
		useContext(GameContext);
	const { toggleMinimize }: any = useContext(ViewContext);
	const [targetId, setTargetId] = useState(-1);

	const performActionTyped = performAction as performActionType;

	if (gameStatus === 1 || gameStatus === 2) {
		return;
	}

	useEffect(() => {
		setTargetId(0);
	}, []);

	function makeChoice(e) {
		e.preventDefault();

		performActionTyped(makeDecisionTurnOrder, { targetId });
		// sendDecisionTurnOrder(currPlayer, targetId);
	}

	const handleTargetChange = (event) => {
		logg('currTarget decision');
		const newTargetId = parseInt(event.target.value) || -1;
		logg(newTargetId);
		setTargetId(newTargetId);
	};

	return (
		<div className="modal">
			<div className="modal-content">
				<span className="close" onClick={toggleMinimize}>
					&minus;
				</span>
				<h2>DECIDE WHICH PLAYER GOES FIRST</h2>
				<div>
					Player:
					<select
						id="targetSelect"
						value={targetId}
						onChange={handleTargetChange}
					>
						{playerStateArray.map((target) => (
							<option
								key={target.playerId}
								value={target.playerId}
							>
								{target.color}
							</option>
						))}
					</select>
				</div>
				<button value={0} onClick={(e) => makeChoice(e)}>
					Confirm Choice
				</button>
			</div>
		</div>
	);
};

export default DecisionTurnOrderModal;
